import { useSnapshot } from 'valtio'
import { type ReactElement, useEffect } from 'react'
import { MerchantUsersTableEnum, proxyNewUser } from '../../../../../shared/proxies/newUserProxy'
import { PlaceholderBox } from '../../../../../shared/components/ui/PlaceholderBox'
import { ErrorBox } from '../../../../../shared/components/ui/ErrorBox'
import { debouncedHandleFetch } from '../NewUserForm/utils'
import { MerchantUsersTableRows } from './MerchantUsersTableRows'
import { MerchantUsersTableHeader } from './MerchantUsersTableHeader'
import { MerchantUsersTableFooter } from './MerchantUsersTableFooter'
import { MerchantUsersTableHeaderNoSort } from './MerchantUsersTableHeaderNoSort'

export function MerchantUsersTable (): ReactElement {
  const { apiCall } = useSnapshot(proxyNewUser)
  useEffect(() => {
    void debouncedHandleFetch()
  }, [])

  return (

    <div className="bg-white shadow rounded w-full">
      <PlaceholderBox loading={apiCall.loading} rows={20} additionalClasses="p-2">
        <ErrorBox error={apiCall.error}>
          <table className="w-full">
            <thead className="text-left">
              <tr>
                <MerchantUsersTableHeader title="User ID" width={20} sortColumn={MerchantUsersTableEnum.Id} />
                <MerchantUsersTableHeader title="First Name" width={20} sortColumn={MerchantUsersTableEnum.FirstName} />
                <MerchantUsersTableHeader title="Last Name" width={20} sortColumn={MerchantUsersTableEnum.LastName} />
                <MerchantUsersTableHeader title="Email" width={20} sortColumn={MerchantUsersTableEnum.Email} />
                <MerchantUsersTableHeader title="Is Admin" width={20} sortColumn={MerchantUsersTableEnum.IsMerchantAdmin} />
                <MerchantUsersTableHeaderNoSort />
              </tr>
            </thead>
            <tbody>
              <MerchantUsersTableRows />
            </tbody>
          </table>
          <hr />
          <MerchantUsersTableFooter />
        </ErrorBox>
      </PlaceholderBox>
    </div>

  )
}
